import { application } from "../../../../../app/javascript/controllers/application"
import IcomosAutosaveController from "./icomos_autosave_controller"

application.register("icomos-autosave", IcomosAutosaveController)

import IcomosPhotosController from "./icomos_photos_controller"
application.register("icomos-photos", IcomosPhotosController)
import IcomosReviewController from "./icomos_review_controller"
application.register("icomos-review", IcomosReviewController)
import IcomosNearbyController from "./icomos_nearby_controller"
application.register("icomos-nearby", IcomosNearbyController)
